<template>

    <div class="example-container">

      <h2>Examples</h2>
      <a v-for="(example, index) in examples" :key="index+'example'" @click="fillExample(example)">{{ example.query }}<br/></a>

    </div>

</template>


<script>
import { mapState, mapActions } from 'vuex'

    export default {
      name: 'QueryExample',
      components: {
      },
      data() {
        return {

        };
      },
      computed: {
        ...mapState(['examples', 'user_query']),
      },
      methods:{
        ...mapActions(['updateInteraction']),
        fillExample(example){
            this.user_query.taxon1 = example.taxon1
            this.user_query.taxon2 = example.taxon2
            this.user_query.interaction = example.interaction
            this.updateInteraction(example.interaction)
        },
      },
    }

</script>


<style scoped lang="scss">

    .example-container {
        margin: 20px 0;
        text-align: left;
    }

</style>
